/**
 * Per-piece preference for the S0 chord-presentation view, persisted in
 * `localStorage`.
 *
 * `flashSeen`: whether the flash mode has already been demonstrated on this
 * piece. The very first flash explains itself instead of auto-advancing,
 * otherwise the screen vanishes before the player understands why.
 *
 * All reads are defensive: `localStorage` throws in private mode on some
 * browsers, and a corrupted value must never break the parcours.
 */

const FLASH_SEEN_KEY_PREFIX = "virtuosa.s0.flashSeen.";

function readFlag(key: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  try {
    return window.localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

function writeFlag(key: string): void {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(key, "1");
  } catch {
    // Storage unavailable (private mode, quota). The preference simply
    // does not persist; the parcours keeps working.
  }
}

/** True once a flash-mode S0 has been shown (and explained) on this piece. */
export function readFlashSeen(songId: string): boolean {
  return readFlag(FLASH_SEEN_KEY_PREFIX + songId);
}

export function writeFlashSeen(songId: string): void {
  writeFlag(FLASH_SEEN_KEY_PREFIX + songId);
}
